import React from 'react';
import TopPicksPanel from '../../../LandingPage/TopPicksPanel';
import SectionContainer from '../SectionContainer';

/**
 * Section component for the TopPicksPanel.
 * Integrates the TopPicksPanel into the PageBuilder system so it can
 * be rendered alongside CMS-driven sections on the landing page.
 */
const SectionTopPicks = props => {
  const {
    sectionId,
    className,
    rootClassName,
    topPicksListings = [],
    appearance,
    options,
    // Extract React-specific props that don't need to be passed down
    defaultClasses,
    isInsideContainer,
    sectionType,
    sectionName,
    // Any remaining props that might be valid DOM attributes
    ...domProps
  } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={options}
      {...domProps}
    >
      <TopPicksPanel listings={topPicksListings} />
    </SectionContainer>
  );
};

export default SectionTopPicks;
